const TOKEN_KEY = 'szxl_token'
const TOKEN_EXPIRES_AT_KEY = 'szxl_token_expires_at'
const USER_KEY = 'szxl_user_info'
const THEME_KEY = 'szxl_theme'
const TOKEN_TTL_MS = 24 * 60 * 60 * 1000

export function getTokenExpiresAt(): number {
  const expiresAt = Number(localStorage.getItem(TOKEN_EXPIRES_AT_KEY) || 0)
  return Number.isFinite(expiresAt) ? expiresAt : 0
}

export function isTokenExpired(): boolean {
  const token = localStorage.getItem(TOKEN_KEY)
  if (!token) return false
  const expiresAt = getTokenExpiresAt()
  return !expiresAt || expiresAt <= Date.now()
}

export function setToken(token: string, expiresAt = Date.now() + TOKEN_TTL_MS) {
  const validExpiresAt = Number.isFinite(expiresAt) && expiresAt > Date.now()
    ? expiresAt
    : Date.now() + TOKEN_TTL_MS
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(TOKEN_EXPIRES_AT_KEY, String(validExpiresAt))
}

export function getToken(): string {
  const token = localStorage.getItem(TOKEN_KEY) || ''
  if (token && isTokenExpired()) {
    clearAuthStorage()
    return ''
  }
  return token
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(TOKEN_EXPIRES_AT_KEY)
}

export function clearAuthStorage() {
  clearToken()
  clearUserInfo()
}

export function setUserInfo(user: any) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function getUserInfo(): any | null {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function clearUserInfo() {
  localStorage.removeItem(USER_KEY)
}

export function clearAll() {
  localStorage.clear()
}

export function setTheme(dark: boolean) {
  localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light')
}

export function isDarkMode(): boolean {
  return localStorage.getItem(THEME_KEY) === 'dark'
}
